import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { VodPageGetter, VodPageState } from "@/components/VoD/types";

export const getters: GetterTree<VodPageState, RootState> &
  Record<VodPageGetter, Getter<VodPageState, RootState>> = {
  [VodPageGetter.GetViewedVodType](state) {
    return state.viewedVodType;
  },
  [VodPageGetter.GetViewedVodIndex](state) {
    return state.viewedVodIndex;
  },
  [VodPageGetter.GetMoviesByGenre](state) {
    return state.moviesByGenre;
  },
  [VodPageGetter.GetTvShowsByGenre](state) {
    return state.tvShowsByGenre;
  },
  [VodPageGetter.GetInfoModalVodId](state) {
    return state.infoModalVodId;
  },
  [VodPageGetter.GetShowVodInfoModal](state) {
    return state.showVodInfoModal;
  },
  [VodPageGetter.GetRefocusCardId](state) {
    return state.refocusCardId;
  },
  [VodPageGetter.GetClosePlayer](state) {
    return state.closePlayer;
  },
  [VodPageGetter.GetCardControls](state) {
    return state.cardControls;
  },
  [VodPageGetter.GetPlayedEpisodePos](state) {
    return state.playedEpisodePos;
  },
  [VodPageGetter.GetShowEpisodeInfoModal](state) {
    return state.showEpisodeInfoModal;
  },
  [VodPageGetter.GetActiveEpisode](state) {
    return state.activeEpisode;
  },
  [VodPageGetter.GetPromoVod](state) {
    return state.promoVoD;
  }
};
